import { useAppSelector } from 'hooks';
import { useFeatureFlag } from 'hooks/useFeatureFlag';

const AUTO_REFORM_EFFECTIVE_DATE = new Date('2026-07-01');

export const useAutoReformEnabled = (): boolean => {
  const isAutoReformFeatureEnabled = useFeatureFlag('enable-auto-reform');
  const provinceCode = useAppSelector(
    (state) => state.autoPersonalForm.data?.applicant?.province_code,
  );
  const effectiveDate = useAppSelector(
    (state) => state.autoPersonalForm.data?.policy_period?.effective_date,
  );

  if (!provinceCode || !effectiveDate) {
    return false;
  }

  const isEffectiveDateValid =
    effectiveDate && new Date(effectiveDate) >= AUTO_REFORM_EFFECTIVE_DATE;

  return (
    isAutoReformFeatureEnabled &&
    provinceCode === 'ON' &&
    Boolean(isEffectiveDateValid)
  );
};
